import { RootState } from "../../store/types";
import { connect } from "react-redux";
import ProjectedBacklogCards from "./index";

const mapStateToProps = (state: RootState) => ({
    backlogProjections: state.reviewAndPublish.shiftPlanOutput?.backlogProjections
});

export default connect(mapStateToProps)(ProjectedBacklogCards);
